import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { Controller, useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Spin } from "antd";
import { CheckCircleOutlined, SoundOutlined, ReloadOutlined } from '@ant-design/icons';
import {
    InfoCircleOutlined,
} from '@ant-design/icons';
import './Registration.scss'
import { BackendAPI } from "../axios";
import { AxiosError } from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { Formik, Field, ErrorMessage, useField, useFormikContext } from 'formik';
import Footer from '../components/common/footer';
import { numberToWords } from './num2words';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Header from '../components/common/header';
import { Button, Col, Input, Form, Row, Divider, Card, Radio, Select, Typography } from 'antd';
import { Section } from './home';

const MySwal = withReactContent(Swal);

interface State {
    state_id: string;
    state_name: string;
}

function RegistrationForm() {
    const navigate = useNavigate();
    const location = useLocation();

    const [active, setActive] = useState<Section>("home");
    const [inputNumber, setInputNumber] = useState<number | string>('');
    const [words, setWords] = useState<string>('');
    const [captchaText, setCaptchaText] = useState('');
    const [loading, setLoading] = useState(false);
    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [otpSent, setOtpSent] = useState(false);
    const [otp, setOtp] = useState('');
    const [verified, setVerified] = useState(false);

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newNumber = parseInt(event.target.value, 10);
        if (isNaN(newNumber)) {
            setInputNumber('');
        } else {

            setInputNumber(newNumber);
        }
        setWords(numberToWords(newNumber));
    };

    const labelStyle = {
        fontWeight: "bold",
        // padding: '0 10px',
        fontSize: '16px',
        // marginBottom: "8px",
    };

    const validationSchema = Yup.object().shape({
        organizationName: Yup.string()
            .required('Organization Name is required')
            .test({
                test: function (value) {
                    const isValid = /^[a-zA-Z0-9!@#$%^&*):;"'\/,.:_-]+(\s+|$)/.test(value.trim()) && value.trim().length >= 5;
                    if (!isValid) {
                        throw new Yup.ValidationError('Organization Name is invalid', value, 'organizationName');
                    }

                    return true;
                },
            }),
        organizationType: Yup.string().required('Organization Type is required'),
        dept: Yup.string().when('organizationType', {
            is: (val: unknown): val is string => val === 'state' || val === 'central',
            then: (schema) => schema.required('This field is required'),
            otherwise: (schema) => schema.notRequired(),
        }),
        ministry: Yup.string().when('organizationType', {
            is: (val: unknown): val is string => val === 'state' || val === 'central',
            then: (schema) => schema.required('This field is required'),
            otherwise: (schema) => schema.notRequired(),
        }),
        registartion_no: Yup.string().when('organizationType', {
            is: (val: unknown): val is string => val === 'private',
            then: (schema) => schema.required('This field is required'),
            otherwise: (schema) => schema.notRequired(),
        }),
        pincode: Yup.string()
            .required('This is required')
            .matches(/^\d+$/, 'Pincode should only contain digits')
            .matches(/^\d{6}$/, 'Pincode should be exactly 6 digits'),
        phone: Yup.string()
            .matches(/^\d{10,11}$/, "Mobile Number must be 10 or 11 digits and contain only numbers") // Only 10 or 11 digits, no characters
            .required("Mobile Number is required"),
        address: Yup.string().required('Address is required')
            .test({
                test: function (value) {
                    const isValid = /^[a-zA-Z0-9!@#$%^&*):;"'\/,.:_-]+(\s+|$)/.test(value.trim()) && value.trim().length >= 5;
                    if (!isValid) {
                        throw new Yup.ValidationError('Address is invalid', value, 'address');
                    }

                    return true;
                },
            }),
        city: Yup.string().required('City is required'),
        state: Yup.string().required('State is required'),
        service_type: Yup.string().required('This field is required'),
        is_alternate_sp: Yup.string().required('This field is required'),
        // aua_kua_code: Yup.string().when('service_type', {
        //     is: (val: unknown): val is string => val === 'asa',
        //     then: (schema) => schema.required('This field is required'),
        //     otherwise: (schema) => schema.notRequired(),
        // }),

        // aua_kua_code_prod: Yup.string().when('service_type', {
        //     is: (val: unknown): val is string => val === 'asa',
        //     then: (schema) => schema.required('This field is required'),
        //     otherwise: (schema) => schema.notRequired(),
        // }),
        alternate_sp_name: Yup.string().when('is_alternate_sp', {
            is: (val: unknown): val is string => val === 'Yes',
            then: (schema) => schema.required('This field is required'),
            otherwise: (schema) => schema.notRequired(),
        }),
        cd_name: Yup.string().required('This field is required'),
        cd_designation: Yup.string().required('This field is required'),
        cdemail: Yup.string().required('This field is required').email('Email should be valid'),
        cd_mobile: Yup.string()
            .matches(/^\d{10,11}$/, "Mobile Number must be 10 or 11 digits and contain only numbers") // Only 10 or 11 digits, no characters
            .required("Mobile Number is required"),
        quarterly_transaction_count: Yup.string().required('This field is required')
            .test({
                test: function (value) {
                    const isValidLength = value && value.length <= 12;
                    const isValidFormat = /^\d+$/.test(value) && parseInt(value, 10) >= 0;

                    if (!isValidLength) {
                        throw new Yup.ValidationError('Enter valid number upto 12', value, 'quarterly_transaction_count');
                    }

                    if (!isValidFormat) {
                        setWords(numberToWords(parseInt(value, 10)).trim());
                        throw new Yup.ValidationError('Transaction count is invalid', value, 'quarterly_transaction_count');
                    }
                    setWords(numberToWords(parseInt(value, 10)));

                    return true;
                },
            }),
        quarterly_transaction_in_words: Yup.string().notRequired(),
        project_description: Yup.string().required('This field is required'),
        project_purpose: Yup.string().required('This field is required'),
        captcha: Yup.string()
            .required('Captcha is required')
            .test(
                'captcha-matches',
                'Incorrect captcha',
                (value) => value === captchaText
            ),
    });

    const { control, watch, handleSubmit, formState: { errors, touchedFields, isSubmitted } } = useForm({
        resolver: yupResolver(validationSchema),
        mode: 'onTouched',
    });

    const onSubmit = async (values: any) => {
        setLoading(true);
        console.log("values => ", values);
        const header = {
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS"
            },
        };
        const url = `/user/register`;
        try {
            const response = await BackendAPI.post(url, values, header);
            if (!response.status) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            } else if (response.status == 200 || response.status == 201) {
                MySwal.fire({
                    icon: 'success',
                    imageWidth: 100,
                    imageHeight: 100,
                    title: 'Check Mail',
                    text: response.data,
                }).then((result) => {
                    if (result.isConfirmed || result.isDismissed) {
                        // Navigate to the root path "/"
                        navigate('/');
                    }
                });
            }
            setLoading(false);
        } catch (error) {
            if (error instanceof AxiosError && error.response?.status === 409) {
                MySwal.fire({
                    icon: 'warning',
                    imageWidth: 100,
                    imageHeight: 100,
                    title: 'Existing User',
                    text: error.response.data,
                });
            } else if (error instanceof AxiosError) {
                MySwal.fire({
                    icon: 'error',
                    imageWidth: 100,
                    imageHeight: 100,
                    title: 'An Unexpected Error Occurred',
                    text: "We are unable to process your request at this time. Please try again later or contact support if the issue persists.",
                });
                console.error("Unexpected error:", error);
            }
            setLoading(false);
        }
    };
    // const [org_details_error, setOrg_details_error] = useState<boolean>(false);


    const [captchaImage, setCaptchaImage] = useState('');
    const [activeStep, setActiveStep] = useState(0);
    const [isModalOpen, setModalOpen] = useState(false);

    const handleOpenModal = () => setModalOpen(true);
    const handleCloseModal = () => setModalOpen(false);
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '70%',
        bgcolor: 'background.paper',
        borderRadius: '10px',
        boxShadow: 24,
        p: 4,
    };


    const getColor = (index: number, activeStep: number) => {
        switch (true) {
            case index < activeStep:
                return 'green'; // Completed step
            case index === activeStep:
                return '#0b66ae'; // Active step
            default:
                return 'gray'; // Incomplete step
        }
    };

    const handleNext = () => {
        setActiveStep((prevStep) => prevStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevStep) => prevStep - 1);
    };

    const gotoStep = (index: number) => {
        setActiveStep(index);
    }

    // const handleInputChange: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> = (event) => {
    //   const inputValue = event.target.value;
    //   setCaptchaInputValue(inputValue);
    // };

    useEffect(() => {
        getStates();
        handleRefreshCaptcha();
    }, []);
    const [states, setStates] = useState<State[]>([]);
    const getStates = async () => {
        const url = `/user/states`;
        const header = {
            headers: {
                "Content-Type": "application/json",
            },
        };
        try {
            const response = await BackendAPI.get(url, header);
            setStates(response.data);
        } catch (error) {
            console.error('Error fetching states:', error);
        }
    };
    const handleRefreshCaptcha = async () => {
        const url = `/user/generate`;
        const header = {
            headers: {
                "Content-Type": "application/json",
            },
        };
        try {
            const response = await BackendAPI.get(url, header);
            setCaptchaImage(response.data.base64Image);
            setCaptchaText(response.data.captchaText);
        } catch (error) {

        }
    };

        const playCaptchaAudio = () => {
        if (!captchaText) return;
        console.warn('Captcha not loaded');
        // Stop any ongoing speech
        window.speechSynthesis.cancel();

        const spokenText = captchaText
            .split('')
            .map(char => {
                if (/[a-z]/.test(char)) return `lowercase ${char}`;
                if (/[A-Z]/.test(char)) return `uppercase ${char}`;
                if (/[0-9]/.test(char)) return `digit ${char}`;
                return char;
            })
            .join(', ');

        const utterance = new SpeechSynthesisUtterance(spokenText);

        utterance.lang = 'en-US';
        utterance.rate = 0.6;   // very slow
        utterance.pitch = 1;
        utterance.volume = 1;

        window.speechSynthesis.speak(utterance);
    };

    // const containerStyles = {
    //     width: isSmallScreen ? '100%' : '80%',
    //     padding: isSmallScreen ? '0px 12px' : '0px 24px',
    //     marginLeft: 'auto',
    //     marginRight: 'auto',
    //     //  backgroundColor: isDarkMode ? 'black' : 'none',
    // };

    useEffect(() => {
        const sections = document.querySelectorAll("section");

        if (location.pathname === "/registrationform") {
            setActive("registrationform");
            return; // skip section intersection observer
        }
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setActive(entry.target.id as Section);
                    }
                });
            },
            { threshold: 0.5 }
        );

        sections.forEach((section) => observer.observe(section));

        return () => observer.disconnect();
    }, []);

    const sendOtp = async (email: string) => {
        try {
            setLoading1(true);
            const header = {
                headers: {
                    "Content-Type": "application/json",
                },
                params: {
                    email: email,
                },
            };
            const url = `/user/sendOtp`;

            const response = await BackendAPI.post(url, {}, header);
            if (response.status === 200) {
                setOtpSent(true);
                toast.success("OTP sent successfully!");
            } else {
                toast.error("Failed to send OTP");
            }
        } catch (error: any) {
            console.error("Error sending OTP:", error.message);
            setLoading1(false);
            toast.error("Something went wrong while sending OTP");
        } finally {
            setLoading1(false);
        }
    };
    const verifyOtp = async () => {
        setLoading2(true);
        if (!otp || otp.trim().length === 0) {
            toast.error("Please enter OTP");
            setLoading2(false);
            return;
        }
        try {            
            const header = {
                headers: {
                    "Content-Type": "application/json",
                },
                params: {
                    email: watch('cdemail'),
                    otp: otp,
                },
            };
            const url = `/user/verifyOtp`;
            const response = await BackendAPI.post(url, {}, header);
            if (response.status === 200) {
                setVerified(true);
                toast.success("OTP verified successfully!");
                setOtp("");
            } else {
                toast.error("Invalid OTP");
                setOtp("");
            }
        } catch (error: any) {
            console.error("Error verifying OTP:", error);
            toast.error(error.response?.data || "Failed to verify OTP");
        } finally {
            setLoading2(false);
        }
    };

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={6000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                pauseOnHover
                theme="colored"
            />
            <Header active={active} />
            <Spin spinning={loading} size='large' style={{ position: 'fixed', }}>
                <div className="container-fluid" style={{ paddingTop: '30px' }}>
                    {/* <Divider /> */}
                    {/* <Container style={{ maxWidth: '100%' }}> */}
                    <Form layout="vertical" onFinish={handleSubmit(onSubmit)}>
                        {/* Organization Details */}
                        <Divider style={{ borderColor: '#0024c4', fontSize: '24px' }}>Details of Organization</Divider>
                        <Card style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)s', marginBottom: '12px', background: '#f4f7f6' }}>

                            <Row gutter={16}>
                                {/* Input 1 */}
                                <Col xs={24} md={12}>
                                    <Form.Item
                                        label={<span style={labelStyle}>Organization Name <span style={{ color: 'red' }}>*</span></span>}
                                        validateStatus={errors.organizationName ? 'error' : ''}
                                        help={(touchedFields.organizationName || isSubmitted) && errors.organizationName ? errors.organizationName.message : ''}
                                    >
                                        <Controller
                                            name="organizationName"
                                            control={control}
                                            render={({ field }) => <Input {...field} style={{ height: '40px' }} className="custom-placeholder" placeholder='Enter Organization Name' />}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12}>
                                    <Form.Item
                                        label={<span style={labelStyle}>Organization Type <span style={{ color: 'red' }}>*</span></span>}
                                        validateStatus={errors.organizationType ? 'error' : ''}
                                        help={(touchedFields.organizationType || isSubmitted) && errors.organizationType ? errors.organizationType.message : ''}
                                    >
                                        <Controller
                                            name="organizationType"
                                            control={control}
                                            rules={{ required: 'Organization Type is required' }}
                                            render={({ field }) => (
                                                <Select
                                                    {...field}
                                                    className="custom-placeholder" placeholder="Select Organization Type"
                                                    style={{ height: 40 }}
                                                    onChange={(value) => field.onChange(value)}
                                                    onBlur={field.onBlur}
                                                    value={field.value}
                                                >
                                                    {/* <Select.Option value="">---Select Organization Type---</Select.Option> */}
                                                    <Select.Option value="state">State</Select.Option>
                                                    <Select.Option value="central">Central</Select.Option>
                                                    <Select.Option value="psu">PSU</Select.Option>
                                                    {/* <Select.Option value="private">Private</Select.Option> */}
                                                </Select>
                                            )}
                                        />
                                    </Form.Item>
                                </Col>
                                {(watch('organizationType') == 'central' || watch('organizationType') == 'state') && (
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label={<span style={labelStyle}>Department (Required only for Government Organization) <span style={{ color: 'red' }}>*</span></span>}
                                            validateStatus={errors.dept ? 'error' : ''}
                                            help={(touchedFields.dept || isSubmitted) && errors.dept ? errors.dept.message : ''}
                                        >
                                            <Controller
                                                name="dept"
                                                control={control}
                                                render={({ field }) => <Input {...field} style={{ height: '40px', }} className="custom-placeholder" placeholder='Department (Required only for Government Organization)' />}
                                            />
                                        </Form.Item>
                                    </Col>
                                )}
                                {(watch('organizationType') == 'central' || watch('organizationType') == 'state') && (
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label={<span style={labelStyle}>Ministry (Required only for Government Organization) <span style={{ color: 'red' }}>*</span></span>}
                                            validateStatus={errors.ministry ? 'error' : ''}
                                            help={(touchedFields.ministry || isSubmitted) && errors.ministry ? errors.ministry.message : ''}
                                        >
                                            <Controller
                                                name="ministry"
                                                control={control}
                                                render={({ field }) => <Input {...field} style={{ height: '40px' }} className="custom-placeholder" placeholder='Ministry (Required only for Government Organization)' />}
                                            />
                                        </Form.Item>
                                    </Col>
                                )}

                                {watch('organizationType') == 'private' && (
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label={<span style={labelStyle}>Registartion Number <span style={{ color: 'red' }}>*</span></span>}
                                            validateStatus={errors.registartion_no ? 'error' : ''}
                                            help={(touchedFields.registartion_no || isSubmitted) && errors.registartion_no ? errors.registartion_no.message : ''}
                                        >
                                            <Controller
                                                name="registartion_no"
                                                control={control}
                                                render={({ field }) => <Input {...field} style={{ height: '40px' }} className="custom-placeholder" placeholder='Reg. No (Required only for Private Org.)' />}
                                            />
                                        </Form.Item>
                                    </Col>
                                )}
                                <Col xs={24} md={12}>
                                </Col>
                                <Col xs={24} md={16}>
                                    <Form.Item
                                        label={<span style={labelStyle}>Address <span style={{ color: 'red' }}>*</span></span>}
                                        validateStatus={errors.address ? 'error' : ''}
                                        help={(touchedFields.address || isSubmitted) && errors.address ? errors.address.message : ''}
                                    >
                                        <Controller
                                            name="address"
                                            control={control}
                                            render={({ field }) => <Input {...field} style={{ height: '40px' }} className="custom-placeholder" placeholder='Enter Address' />}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={8}>
                                    <Form.Item
                                        label={<span style={labelStyle}>State <span style={{ color: 'red' }}>*</span></span>}
                                        validateStatus={errors.state ? 'error' : ''}
                                        help={(touchedFields.state || isSubmitted) && errors.state ? errors.state.message : ''}
                                    >
                                        <Controller
                                            name="state"
                                            control={control}
                                            rules={{ required: 'Organization Type is required' }}
                                            render={({ field }) => (
                                                <Select
                                                    {...field}
                                                    showSearch
                                                    className="custom-placeholder" placeholder="Select States"
                                                    style={{ height: 40 }}
                                                    onChange={(value) => field.onChange(value)}
                                                    onBlur={field.onBlur}
                                                    value={field.value}
                                                    optionFilterProp="children"
                                                >
                                                    <Select.Option value="">---Select State---</Select.Option>
                                                    {states.map((state) => (
                                                        <Select.Option key={state.state_id} value={state.state_id}>
                                                            {state.state_name}
                                                        </Select.Option>
                                                    ))}

                                                </Select>
                                            )}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={8}>
                                    <Form.Item
                                        label={<span style={labelStyle}>City <span style={{ color: 'red' }}>*</span></span>}
                                        validateStatus={errors.city ? 'error' : ''}
                                        help={(touchedFields.city || isSubmitted) && errors.city ? errors.city.message : ''}
                                    >
                                        <Controller
                                            name="city"
                                            control={control}
                                            render={({ field }) => <Input {...field} style={{ height: '40px' }} className="custom-placeholder" placeholder='Enter City' />}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={8}>
                                    <Form.Item
                                        label={<span style={labelStyle}>Pincode <span style={{ color: 'red' }}>*</span></span>}
                                        validateStatus={errors.pincode ? 'error' : ''}
                                        help={(touchedFields.pincode || isSubmitted) && errors.pincode ? errors.pincode.message : ''}
                                    >
                                        <Controller
                                            name="pincode"
                                            control={control}
                                            render={({ field }) => <Input {...field} style={{ height: '40px' }} className="custom-placeholder" placeholder='Enter Pincode' />}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={8}>
                                    <Form.Item
                                        label={<span style={labelStyle}>Phone <span style={{ color: 'red' }}>*</span></span>}
                                        validateStatus={errors.phone ? 'error' : ''}
                                        help={(touchedFields.phone || isSubmitted) && errors.phone ? errors.phone.message : ''}
                                    >
                                        <Controller
                                            name="phone"
                                            control={control}
                                            render={({ field }) => <Input {...field} style={{ height: '40px' }} />}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Card>

                        {/* Service Requested */}
                        <Divider style={{ borderColor: '#0024c4', fontSize: '24px' }}>Service Requested </Divider>
                        <Card style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)s', marginBottom: '12px', background: '#f4f7f6' }}>

                            <Row gutter={16}>
                                {/* Input 1 */}
                                <Col xs={24} md={12}>
                                    <Card>
                                        <Form.Item style={{ marginBottom: '6px' }}
                                            label={<span style={labelStyle}>Service Type <span style={{ color: 'red' }}>*</span></span>}
                                            validateStatus={errors.service_type ? 'error' : ''}
                                            help={
                                                (touchedFields.service_type || isSubmitted) && errors.service_type
                                                    ? errors.service_type.message
                                                    : ''
                                            }
                                        >
                                            <Controller
                                                name="service_type"
                                                control={control}
                                                render={({ field }) => (
                                                    <Radio.Group
                                                        {...field}
                                                        buttonStyle="solid"
                                                        style={{ display: 'flex', }}
                                                    >
                                                        <Radio.Button style={{ borderRadius: '20px 0px 0px 20px' }} value="asa">ASA</Radio.Button>
                                                        <Radio.Button style={{ borderRadius: '0px 20px 20px 0px' }} value="aua">AUA</Radio.Button>
                                                    </Radio.Group>

                                                )}
                                            />
                                        </Form.Item>
                                        {/* ✅ Selected Value Shown Outside Form.Item */}
                                        {/* {watch('service_type') == 'asa' && (
                                            <Form.Item
                                                label={<span style={labelStyle}>AUA/KUA Code for Pre-Production <span style={{ color: 'red' }}>*</span></span>}
                                                validateStatus={errors.aua_kua_code ? 'error' : ''}
                                                help={(touchedFields.aua_kua_code || isSubmitted) && errors.aua_kua_code ? errors.aua_kua_code.message : ''}
                                            >
                                                <Controller
                                                    name="aua_kua_code"
                                                    control={control}
                                                    rules={{
                                                        required: watch('service_type') === 'ASA' ? 'This field is required' : false,
                                                    }}
                                                    render={({ field }) => <Input {...field} style={{ height: '40px' }} className="custom-placeholder" placeholder='Enter AUA/KUA Code for Pre-Production' />}
                                                />
                                            </Form.Item>
                                        )}
                                        {watch('service_type') == 'asa' && (
                                            <Form.Item
                                                label={<span style={labelStyle}>AUA/KUA Code for Production <span style={{ color: 'red' }}>*</span></span>}
                                                validateStatus={errors.aua_kua_code_prod ? 'error' : ''}
                                                help={(touchedFields.aua_kua_code_prod || isSubmitted) && errors.aua_kua_code_prod ? errors.aua_kua_code_prod.message : ''}
                                            >
                                                <Controller
                                                    name="aua_kua_code_prod"
                                                    control={control}
                                                    rules={{
                                                        required: watch('service_type') === 'AUA' ? 'This field is required' : false,
                                                    }}
                                                    render={({ field }) => <Input {...field} style={{ height: '40px' }} className="custom-placeholder" placeholder='Enter AUA/KUA Code for Production' />}
                                                />
                                            </Form.Item>
                                        )} */}
                                    </Card>
                                </Col>
                                <Col xs={24} md={12}>
                                    <Card>
                                        <span style={{ fontSize: '16px', fontWeight: '600' }}>
                                            Are you already using or planning to use services of any other ASA/KSA or AUA service provider other than C-DAC? <span style={{ color: 'red' }}>*</span>
                                        </span>
                                        <Form.Item style={{ marginBottom: '6px' }}
                                            label={<span style={labelStyle}>Confirm</span>}
                                            validateStatus={errors.is_alternate_sp ? 'error' : ''}
                                               help={
                                                (touchedFields.is_alternate_sp || isSubmitted) && errors.is_alternate_sp
                                                    ? errors.is_alternate_sp.message
                                                    : ''
                                            }
                                        >
                                            <Controller
                                                name="is_alternate_sp"
                                                control={control}
                                                render={({ field }) => (
                                                    <Radio.Group
                                                        {...field}
                                                        buttonStyle="solid"
                                                        style={{ display: 'flex', }}
                                                    >
                                                        <Radio.Button type='text' style={{ borderRadius: '20px 0px 0px 20px' }} value="Yes">Yes</Radio.Button>
                                                        <Radio.Button type='text' style={{ borderRadius: '0px 20px 20px 0px' }} value="No">No</Radio.Button>
                                                    </Radio.Group>

                                                )}
                                            />
                                        </Form.Item>
                                        {watch('is_alternate_sp') == 'Yes' && (
                                            <Form.Item
                                                label={<span style={labelStyle}>Alternate service provider name <span style={{ color: 'red' }}>*</span></span>}
                                                validateStatus={errors.alternate_sp_name ? 'error' : ''}
                                                help={(touchedFields.alternate_sp_name || isSubmitted) && errors.alternate_sp_name ? errors.alternate_sp_name.message : ''}
                                            >
                                                <Controller
                                                    name="alternate_sp_name"
                                                    control={control}
                                                    rules={{
                                                        required: watch('is_alternate_sp') === 'Yes' ? 'This field is required' : false,
                                                    }}
                                                    render={({ field }) => <Input {...field} style={{ height: '40px' }} className="custom-placeholder" placeholder='Alternate service provider name' />}
                                                />
                                            </Form.Item>
                                        )}
                                    </Card>
                                </Col>
                            </Row>
                        </Card>

                        {/* Contact Person Information */}
                        <Row gutter={[16, 16]} style={{}}>
                            <Col xs={24} md={12}>
                                <Divider style={{ borderColor: '#0024c4', fontSize: '24px' }}>Contact Person Information <span style={{ color: 'red' }}>*</span></Divider>
                                <Card style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)s', marginBottom: '12px', background: '#f4f7f6' }}>

                                    <Form.Item
                                        label={<span style={labelStyle}>Contact Person Name <span style={{ color: 'red' }}>*</span></span>}
                                        validateStatus={errors.cd_name ? 'error' : ''}
                                        help={(touchedFields.cd_name || isSubmitted) && errors.cd_name ? errors.cd_name.message : ''}
                                    >
                                        <Controller
                                            name="cd_name"
                                            control={control}
                                            render={({ field }) => <Input {...field} style={{ height: '40px' }} className="custom-placeholder" placeholder='Enter Contact Person Name' />}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label={<span style={labelStyle}>Contact Person Designation <span style={{ color: 'red' }}>*</span></span>}
                                        validateStatus={errors.cd_designation ? 'error' : ''}
                                        help={(touchedFields.cd_designation || isSubmitted) && errors.cd_designation ? errors.cd_designation.message : ''}
                                    >
                                        <Controller
                                            name="cd_designation"
                                            control={control}
                                            render={({ field }) => <Input {...field} style={{ height: '40px' }} className="custom-placeholder" placeholder='Enter Contact Person Designation' />}
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        label={<span style={labelStyle}>Contact Person Email ID <span style={{ color: 'red' }}>*</span></span>}
                                        validateStatus={errors.cdemail ? 'error' : verified ? 'success' : ''}
                                        help={(touchedFields.cdemail || isSubmitted) && errors.cdemail ? errors.cdemail.message : ''}
                                    >
                                        <Controller
                                            name="cdemail"
                                            control={control}
                                            render={({ field }) => (
                                                <Input
                                                    {...field}
                                                    style={{ height: '40px', borderColor: verified ? 'green' : undefined, border: verified ? '1px solid green' : undefined }}
                                                    className="custom-placeholder"
                                                    placeholder='Enter Contact Person Email ID'
                                                    disabled={verified}
                                                    suffix={
                                                        !verified ? (
                                                            <Button
                                                                type="primary"
                                                                size="small"
                                                                onClick={() => sendOtp(watch('cdemail'))}
                                                                loading={loading1}
                                                                disabled={otpSent && !verified}
                                                                style={{ height: '100%', marginRight: '-6px', width: '70px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}
                                                            >
                                                                Verify
                                                            </Button>
                                                        ) : (
                                                            <CheckCircleOutlined style={{ color: 'green', fontSize: '26px', }} />
                                                        )
                                                    }
                                                />
                                            )}
                                        />
                                    </Form.Item>
                                    {/* ---- Separate OTP Field ---- */}
                                    {otpSent && !verified && (
                                        <Form.Item label={<span style={labelStyle}>Enter OTP <span style={{ color: 'red' }}>*</span></span>}>
                                            <div style={{ display: "flex", gap: "10px" }}>
                                                <Input
                                                    className="custom-otp-input"
                                                    value={otp}
                                                    onChange={(e) => setOtp(e.target.value)}
                                                    placeholder="Enter OTP"
                                                    style={{ height: '40px', width: '60%', fontSize: '20px' }}
                                                    suffix={
                                                        <Button
                                                            type="primary"
                                                            size='small'
                                                            onClick={verifyOtp}
                                                            loading={loading2}
                                                            style={{ height: '100%', marginRight: '-6px', paddingLeft: '10px', paddingRight: '10px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}
                                                        >
                                                            Verify OTP
                                                        </Button>
                                                    }
                                                />
                                                
                                            </div>
                                        </Form.Item>
                                    )}


                                    <Form.Item
                                        label={<span style={labelStyle}>Contact Person Number <span style={{ color: 'red' }}>*</span></span>}
                                        validateStatus={errors.cd_mobile ? 'error' : ''}
                                        help={(touchedFields.cd_mobile || isSubmitted) && errors.cd_mobile ? errors.cd_mobile.message : ''}
                                    >
                                        <Controller
                                            name="cd_mobile"
                                            control={control}
                                            render={({ field }) => <Input {...field} style={{ height: '40px' }} className="custom-placeholder" placeholder='Enter Contact Person Number' />}
                                        />
                                    </Form.Item>
                                </Card>
                            </Col>


                            {/* Expected Quarterly Transactions (3 months) */}
                            <Col xs={24} md={12}>
                                <Divider style={{ borderColor: '#0024c4', fontSize: '24px', whiteSpace: 'pre-wrap' }}>Expected Annual Transactions <span style={{ color: 'red' }}>*</span></Divider>
                                <Card style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)s', marginBottom: '12px', background: '#f4f7f6' }}>

                                    <Form.Item
                                        label={<span style={labelStyle}>Transections in Figures <span style={{ color: 'red' }}>*</span></span>}
                                        validateStatus={errors.quarterly_transaction_count ? 'error' : ''}
                                        help={(touchedFields.quarterly_transaction_count || isSubmitted) && errors.quarterly_transaction_count ? errors.quarterly_transaction_count.message : ''}
                                    >
                                        <Controller
                                            name="quarterly_transaction_count"
                                            control={control}
                                            render={({ field }) => <Input {...field} style={{ height: '40px' }} className="custom-placeholder" placeholder='Enter Transections in Figures'
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                    const value = e.target.value;
                                                    field.onChange(value); // Update RHF state
                                                    // Custom logic (you can handle additional tasks here)
                                                    const numericValue = parseInt(value, 10);
                                                    setWords(numberToWords(numericValue));
                                                }}
                                            />}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label={<span style={labelStyle}>Transections in Word</span>}
                                        validateStatus={errors.quarterly_transaction_in_words ? 'error' : ''}
                                        help={(touchedFields.quarterly_transaction_in_words || isSubmitted) && errors.quarterly_transaction_in_words ? errors.quarterly_transaction_in_words.message : ''}
                                    >
                                        <Controller
                                            name="quarterly_transaction_in_words"
                                            control={control}
                                            disabled={true}
                                            render={({ field }) => <Input {...field} value={words || ''} style={{ height: '40px', color: 'black', }} className="custom-placeholder" placeholder='Transections in words' />}
                                        />
                                    </Form.Item>
                                </Card>
                            </Col>
                        </Row>

                        {/* Project/Application Description */}
                        <Row style={{ placeContent: 'space-between' }}>
                            <Col xs={24} md={11}>
                                <Divider style={{ borderColor: '#0024c4', fontSize: '24px' }}>Project/Application Description </Divider>
                                <Card style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)s', marginBottom: '12px', background: '#f4f7f6' }}>
                                    <Form.Item
                                        label={<span style={labelStyle}>Project Description <span style={{ color: 'red' }}>*</span></span>}
                                        validateStatus={errors.project_description ? 'error' : ''}
                                        help={(touchedFields.project_description || isSubmitted) && errors.project_description ? errors.project_description.message : ''}
                                    >
                                        <Controller
                                            name="project_description"
                                            control={control}
                                            render={({ field }) => <Input.TextArea {...field} style={{ height: '70px', resize: 'none' }} className="custom-placeholder" placeholder="Name and brief description of the project/application for which ASA/KSA or AUA services will be utilized." />}
                                        />
                                    </Form.Item>
                                </Card>
                            </Col>


                            {/* Project Purpose */}
                            <Col xs={24} md={11}>
                                <Divider style={{ borderColor: '#0024c4', fontSize: '24px' }}>Project Purpose</Divider>
                                <Card style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)s', marginBottom: '12px', background: '#f4f7f6' }}>
                                    <Form.Item
                                        label={<span style={labelStyle}>Project Purpose <span style={{ color: 'red' }}>*</span></span>}
                                        validateStatus={errors.project_purpose ? 'error' : ''}
                                        help={(touchedFields.project_purpose || isSubmitted) && errors.project_purpose ? errors.project_purpose.message : ''}
                                    >
                                        <Controller
                                            name="project_purpose"
                                            control={control}
                                            render={({ field }) => <Input.TextArea {...field} style={{ height: '70px', resize: 'none' }} className="custom-placeholder" placeholder="Enter the purpose of the project/application for which ASA/KSA or AUA services will be utilized." />}
                                        />
                                    </Form.Item>
                                </Card>
                            </Col>


                        </Row>

                        {/* Captcha */}
                        <Row style={{ justifyContent: 'center', }}>
                            <Col xs={24} md={12} style={{ placeContent: 'center' }}>
                                <Divider style={{ borderColor: '#0024c4', fontSize: '24px', pointerEvents: 'none' }}>Captcha Verification</Divider>
                                <Card style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)s', marginBottom: '12px', background: '#f4f7f6', padding: '12px',  }} bodyStyle={{ padding: '0px' }}>
                                    {/* <div style={{ textAlign: 'center', userSelect: 'none' }}>
                                        <img src={`data:image/png;base64,${captchaImage}`} alt="CAPTCHA" style={{ width: '50%' }} />
                                    </div> */}
                                    <Col
                                        xs={24}
                                        md={12}
                                        lg={12}
                                        style={{
                                            marginBottom: 0,
                                            display: 'flex',
                                            gap: '6px',
                                            margin: '0 auto', // centers the column itself
                                        }}
                                    >
                                        <div
                                            style={{
                                                color: "#fff",
                                                width: '100%',
                                                borderRadius: '10px',
                                                border: '2ps solid blue',
                                                // padding: "8px 16px",
                                                // borderRadius: 6,
                                                // fontWeight: 600,
                                                // letterSpacing: 3,
                                                // display: "inline-block",
                                                // marginBottom: 8
                                            }}
                                        >
                                            <img src={`data:image/png;base64,${captchaImage}`} alt="CAPTCHA" style={{ width: '100%', height: '50px', borderRadius: '10px', border: '2px solid #1515b4' }} />
                                        </div>

                                        <Button
                                            type="link"
                                            onClick={handleRefreshCaptcha}
                                            style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', fontSize: '24px,', height: '50px', color: 'white', width: '12%', }}
                                        >
                                            <ReloadOutlined />
                                        </Button>
                                        <Button
                                            type="link"
                                            onClick={playCaptchaAudio}
                                            style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', fontSize: '24px,', height: '50px', color: 'white', width: '12%', }}
                                        >
                                            <SoundOutlined />
                                        </Button>
                                    </Col>
                                    {/* <Row style={{ placeSelf: 'center', }} > */}
                                        <Col xs={24} md={12} lg={12}
                                        style={{justifySelf: 'center', width: '100%', marginTop: '6px', }}
                                        >
                                            <Form.Item
                                                // label={<span style={labelStyle}>Department (Required only for Government Organization)</span>}
                                                validateStatus={errors.captcha ? 'error' : ''}
                                                help={(touchedFields.captcha || isSubmitted) && errors.captcha ? errors.captcha.message : ''}
                                            >
                                                <Controller
                                                    name="captcha"
                                                    control={control}
                                                    render={({ field }) => <Input {...field} style={{ height: '40px', }} className="custom-placeholder" placeholder='Enter Captcha' />}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={6} md={6} lg={6}>
                                                
                                        </Col>
                                    {/* </Row> */}
                                </Card>
                            </Col>
                        </Row>


                        <Form.Item style={{ textAlignLast: 'center' }}>
                            <Button type="primary" htmlType="submit" style={{ width: '50%', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
                                Submit
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </Spin>
        </>
    )
}

export default RegistrationForm
